import { useEffect, useState } from "react";
import { api } from "../api";

const Stat = ({ label, value, gold, testId }) => (
    <div className="rounded-2xl border border-lakou-gold/15 bg-lakou-coal/60 p-4" data-testid={testId}>
        <div className="font-mono2 text-[9px] uppercase tracking-[0.2em] text-lakou-sand">{label}</div>
        <div className={`mt-1.5 font-display font-black text-2xl ${gold ? "text-goldgrad" : "text-lakou-cream"}`}>{value}</div>
    </div>
);

export const ControlDashboard = () => {
    const [d, setD] = useState(null);
    const [updatedAt, setUpdatedAt] = useState(null);

    useEffect(() => {
        let on = true;
        const load = () => api.get("/control/overview").then((r) => { if (on) { setD(r.data); setUpdatedAt(new Date()); } }).catch(() => {});
        load();
        const t = setInterval(load, 10000);   // real-time refresh: purchases, confirmations, scans
        return () => { on = false; clearInterval(t); };
    }, []);

    if (!d) return <p className="text-lakou-sand text-sm" data-testid="dashboard-loading">Loading…</p>;

    return (
        <div data-testid="control-dashboard" className="space-y-5">
            <div className="flex items-center justify-between">
                <h1 className="font-display font-black text-xl">Dashboard</h1>
                <span className="font-mono2 text-[9px] uppercase tracking-[0.2em] text-lakou-sand" data-testid="dashboard-updated">
                    auto-refresh 10s{updatedAt ? ` · ${updatedAt.toLocaleTimeString()}` : ""}
                </span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                <Stat label="Tickets sold" value={d.tickets_sold} testId="stat-sold" />
                <Stat label="Total revenue" value={`$${d.revenue.toFixed(2)}`} gold testId="stat-revenue" />
                <Stat label="Confirmed payments" value={d.confirmed_payments} testId="stat-confirmed" />
                <Stat label="Pending payments" value={`${d.pending_payments} · $${d.pending_amount.toFixed(2)}`} testId="stat-pending" />
                <Stat label="General Admission" value={d.ga_sold} testId="stat-ga" />
                <Stat label="VIP (Behind the Deck)" value={d.vip_sold} testId="stat-vip" />
                <Stat label="Checked in" value={d.checked_in} testId="stat-checked" />
                <Stat label="Remaining to check in" value={d.remaining_checkin} testId="stat-remaining" />
                <Stat label="Total expenses" value={`$${d.expenses_total.toFixed(2)}`} testId="stat-expenses" />
                <Stat label="Net profit" value={`$${d.net_profit.toFixed(2)}`} gold testId="stat-profit" />
            </div>
            <div className="grid grid-cols-3 gap-3">
                <Stat label="Stripe" value={`$${d.revenue_card.toFixed(2)}`} testId="stat-rev-card" />
                <Stat label="MonCash" value={`$${d.revenue_moncash.toFixed(2)}`} testId="stat-rev-moncash" />
                <Stat label="NatCash" value={`$${d.revenue_natcash.toFixed(2)}`} testId="stat-rev-natcash" />
            </div>
        </div>
    );
};
